"use client";

import dynamic from "next/dynamic";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import { Reveal } from "@/components/landing/Reveal";

// Above the fold loads with the page; everything below is split into its own
// chunk. Still server-rendered (dynamic() keeps SSR), so search engines and
// first paint see the full page; only the JS arrives lazily.
const Services = dynamic(() => import("@/components/landing/Services"));
const About = dynamic(() => import("@/components/landing/About"));
const Team = dynamic(() => import("@/components/landing/Team"));
const Gallery = dynamic(() => import("@/components/landing/Gallery"));
const Reviews = dynamic(() => import("@/components/landing/Reviews"));
const FAQ = dynamic(() => import("@/components/landing/FAQ"));
const Contact = dynamic(() => import("@/components/landing/Contact"));
const Footer = dynamic(() => import("@/components/landing/Footer"));

const Landing = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Reveal><Services /></Reveal>
      <Reveal><About /></Reveal>
      <Reveal><Team /></Reveal>
      <Reveal><Gallery /></Reveal>
      <Reveal><Reviews /></Reveal>
      <Reveal><FAQ /></Reveal>
      <Reveal><Contact /></Reveal>
      <Footer />
    </div>
  );
};

export default Landing;
